import { isVisible } from '../helper/element';

const videoElements = document.querySelectorAll( 'video[data-autoplay]' );

/**
 * Should the injected video play? If visible then yes.
 *
 * @param {HTMLVideoElement} element Video element.
 */
const shouldVideoPlay = ( element ) => {
	if ( isVisible( element ) ) {
		element.play();
	} else {
		element.pause();
	}
};

/**
 * Check if the video elements should play or not.
 */
export const autoplayVideos = () => {
	if ( ! videoElements ) {
		return;
	}

	[ ...videoElements ].map( shouldVideoPlay );

	window.onscroll = () => {
		[ ...videoElements ].map( shouldVideoPlay );
	};

	window.onorientationchange = () => {
		[ ...videoElements ].map( shouldVideoPlay );
	};
};
